import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Text,
  UserAvatar,
  Space,
  IconArrowDown,
} from '@redlink/components/atoms';

export const DashboardHeaderUserInfo = memo(
  ({ title, subtitle, imageUrl, transparent = false }) => {
    const { styles, colors } = useStyle();
    return (
      <View
        style={[styles.container, !transparent && styles.containerBackground]}
      >
        <UserAvatar source={{ uri: imageUrl }} style={styles.avatar} />
        <Space size={8} />
        <View>
          <Text style={styles.titleText}>{title}</Text>
          <Text style={styles.subtitleText} numberOfLines={1}>
            {subtitle}
          </Text>
        </View>
        <Space size={4} />
          {!transparent && <IconArrowDown color={colors.gray21} size={14} />}
      </View>
    );
  }
);

const useStyle = createUseStyle(
  ({ colors, size, shadow, ltrFlexDirection }) => ({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 5,
      paddingVertical: 5,
      borderRadius: 24,
      maxWidth: 250,
    },
    containerBackground: {
      backgroundColor: colors.gray7,
    },
    avatar: {
      width: 42,
      height: 42,
    },
    titleText: {
      fontSize: 14,
      color: colors.gray23,
      fontWeight: '600',
      textAlign: 'left',
    },
    subtitleText: {
      fontSize: 12,
      color: colors.gray23,
      textAlign: 'left',
    },
  })
);
